export const INVENTORY_QUERY_DEBOUNCE_VALUE = 200;
